import { assign, entryId, validNumber } from "../../helper.js";
import { OrderType, OrderTypeList } from "../schema/indexColumn.entity.js";
import { isNil, isPlainObject, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/indexColumn.entity.js
var createIndexColumn = () => ({
	id: "",
	indexId: "",
	columnId: "",
	orderType: OrderType.ASC
});
function createAndMergeIndexColumnEntities(json) {
	const entities = {};
	if (!isPlainObject(json) || isNil(json)) return entities;
	for (const [key, value] of Object.entries(json)) {
		if (!isPlainObject(value)) continue;
		const target = createIndexColumn();
		const assignString = assign(isString, target, value);
		target.id = entryId(key, value);
		assignString("indexId");
		assignString("columnId");
		assign(validNumber(OrderTypeList), target, value)("orderType");
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeIndexColumnEntities, createIndexColumn };
